import { EntityLabels, ListPageTitles } from "../../utils/navigation/pageTitles";
import { WasteMovementListPage } from "./WasteMovementListPage";

const WasteReceivedListPage = () => (
    <WasteMovementListPage
        config={{
            movementDirection: "Received",
            listTitle: ListPageTitles.wasteReceived,
            entityLabel: EntityLabels.wasteReceived,
            listPath: "/waste-received",
            editPathPrefix: "/waste-received",
            description: "Daily waste received records aligned with EA waste return columns.",
            persistanceKey: "WasteReceivedListPage",
            siteStorageKey: "WasteReceivedListPage.siteId",
        }}
    />
);

export { WasteReceivedListPage };
